import isElectron from 'is-electron';
import QueryString from 'query-string';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Redirect, Switch, useHistory, useLocation } from 'react-router-dom';
import styled from 'styled-components';

import LoadingProgress from '../../components/LoadingProgess';
import { CONTEXT_PATH } from '../../env/variables';
import { CommunicationMessageTypes } from '../../helpers/constants';
import useCommunicator from '../../hooks/useCommunicator';
import useLessonReplay from '../../hooks/useLessonReplay';
import useSystemReadyWithMonitors from '../../hooks/useSystemReadyWithMonitors';
import {
  setPlayerMode,
  setPlayerRole,
} from '../../store/actions/resources.actions';
import { IControlMessage } from '../../types/communicator-types';
import appRoutes from '../App/routes';

export interface IHermesysProps {
  lessonDef?: any;
}
const Container = styled.div`
  display: block;
`;
const stripPx = (x: any) => x.replace(/px/g, '');

export default function Hermesys(props: IHermesysProps) {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const {
    mode,
    role,
    system,
    unit,
    token,
    version,
    tct,
    enrollId,
    attemptType,
    subjectId,
  } = QueryString.parse(location.search);
  const { systemReady, resetSystem } = useSystemReadyWithMonitors(1);

  const { t } = useTranslation();
  useLessonReplay(
    {
      system: `${system}`,
      unit: `${unit}`,
      token: `${token}`,
      version: `${version}`,
      mode: `${mode}`,
      role: `${role}`,
      tct: `${tct}`,
      enrollId: `${enrollId}`,
      attemptType: `${attemptType}`,
      subjectId: `${subjectId}`,
    },
    resetSystem
  );
  const communicator = useCommunicator<IControlMessage>(
    CommunicationMessageTypes.ControlMessage
  );

  const [restartPalyer, setRestartPlayer] = useState({});
  useEffect(() => {
    console.log('Hermesys starting');
    if (location.pathname === '/hermesys') {
      //Added a 2 seconds delay before opening the other monitors, Will remove once the resources loading isssue is solved
      if (!isElectron()) {
        setTimeout(() => {
          window.open(
            `${window.location.origin}${CONTEXT_PATH}/app/nots_player/lesson-controller?mode=${mode}&system=hermsys`,
            `Lesson Controller`,
            `resizable=off,left=1600,top=200,width=400,height=150`
          );

          // window.open(
          //   `${window.location.origin}${CONTEXT_PATH}/app/nots_player${appRoutes.HERMESYS_GX4100}?mode=${mode}`,
          //   `GX4100`,
          //   `resizable=off,left=200,top=200,width=${stripPx(
          //     '1000px'
          //   )},height=${stripPx('480px')}`
          // );
          // window.open(
          //   `${window.location.origin}${CONTEXT_PATH}/app/nots_player${appRoutes.HERMESYS_AVA20}?mode=${mode}`,
          //   `AVA20`,
          //   `resizable=off,left=200,top=200,width=${stripPx(
          //     '920px'
          //   )},height=${stripPx('300px')}`
          // );
        }, 2000);
      }
    }
  }, [location.pathname, restartPalyer]);

  useEffect(() => {
    dispatch(setPlayerMode(mode));
    dispatch(setPlayerRole(role));
  }, [mode, role, dispatch]);

  if (!systemReady) {
    return <LoadingProgress message={t('loadingProgress.screenLoad')} />;
  }

  return (
    <Container>
      <Switch>
        <Redirect
          exact
          from="/hermesys"
          to={{ ...location, pathname: appRoutes.HERMESYS_MAIN }}
        />
      </Switch>
    </Container>
  );
}
